// extracted by mini-css-extract-plugin
export default {"fields":"JLr63t","time":"o4GjHI","mobile":"OJbHer"};